// The reading week, as the Weekly Report's filter treats it.
//
// The backend stores and reports on a TUESDAY -> MONDAY week; operators read
// it as MONDAY -> SUNDAY. So the filter dialog shows the week shifted back
// one day and shifts the user's pick forward again before it reaches state.
// State always holds the real Tue/Mon pair; only the pickers and labels use
// the shifted ("display") dates.

const DISPLAY_OFFSET_DAYS = -1;

// Today in Chicago, as a Date at 12:00 UTC so local-date maths never slips a day
export const getHoustonToday = () => {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Chicago',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(new Date());
  const get = (type) => parts.find((p) => p.type === type).value;
  return new Date(
    Date.UTC(get('year'), get('month') - 1, get('day'), 12, 0, 0)
  );
};

export const shiftDays = (date, days) => {
  if (!date) return null;
  const shifted = new Date(date);
  shifted.setDate(date.getDate() + days);
  return shifted;
};

// The Monday that closes the reading week opened by the given Tuesday
export const getMondayFromTuesday = (tuesday) => shiftDays(tuesday, 6);

// Stored Tue -> Mon pair for the current reading week
export const getCurrentReadingWeek = () => {
  const today = getHoustonToday();
  const day = today.getDay();
  const diffToLastTuesday = day >= 2 ? day - 2 : 7 - (2 - day);
  const fromDate = shiftDays(today, -diffToLastTuesday);
  return { fromDate, toDate: getMondayFromTuesday(fromDate) };
};

// Stored (Tue/Mon) -> shown (Mon/Sun)
export const toDisplayDate = (date) => shiftDays(date, DISPLAY_OFFSET_DAYS);

// Shown (Mon/Sun) -> stored (Tue/Mon)
export const fromDisplayDate = (date) => shiftDays(date, -DISPLAY_OFFSET_DAYS);

// What the From picker may land on, in display space
export const isMonday = (date) => !!date && date.getDay() === 1;

// A week other than the current one
export const isNotCurrentWeek = (fromDate) =>
  !!fromDate &&
  fromDate.toDateString() !== getCurrentReadingWeek().fromDate.toDateString();

// 'Week: Sep 14 – Sep 20, 2026', in display space
export const formatWeekLabel = (fromDate, toDate) => {
  const fmt = (d, withYear) =>
    toDisplayDate(d).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      ...(withYear ? { year: 'numeric' } : {}),
    });
  return `Week: ${fmt(fromDate)} – ${fmt(toDate, true)}`;
};
